import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { Box, Tooltip } from '@mui/material'
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro'
import { renderColorByString } from 'components/DataGrid/renderColorByString'
import { DensityStyleTypes } from 'types'
import MicrosoftSvg from '../../../../images/icons/bing.png'
import GoogleSearchSvg from '../../../../images/icons/Google Ads.png'
import GoogleDisplaySvg from '../../../../images/icons/Google Display.png'
import LinkedInSvg from '../../../../images/icons/linkedin.svg'
import MetaLightSvg from '../../../../images/icons/meta_1.svg'
import Seo4Svg from '../../../../images/icons/seo.png'
import Seo1Svg from '../../../../images/icons/seotier1.svg'
import Seo2Svg from '../../../../images/icons/seotier2.svg'
import Seo3Svg from '../../../../images/icons/seotier3.svg'
import SimplifiSvg from '../../../../images/icons/simplifi_logo.svg'
import SnapchatSvg from '../../../../images/icons/snapchat.svg'
import SpotifySvg from '../../../../images/icons/spotify.svg'
import TikTokSvg from '../../../../images/icons/tik-tok.png'
import YoutubeSvg from '../../../../images/icons/youtube.svg'

const channelsArray = [
  {
    field: 'isGoogleDisplay',
    headerName: 'Google Display',
    src: GoogleDisplaySvg,
  },
  {
    field: 'isGoogleSearch',
    headerName: 'Google Search',
    src: GoogleSearchSvg,
  },
  { field: 'isLinkedIn', headerName: 'LinkedIn', src: LinkedInSvg },
  {
    field: 'isMetaAdvertising',
    headerName: 'Meta Advertising',
    src: MetaLightSvg,
  },
  {
    field: 'isMicrosoftAdvertising',
    headerName: 'Microsoft',
    src: MicrosoftSvg,
  },
  { field: 'isSimplifi', headerName: 'Simplifi', src: SimplifiSvg },
  { field: 'isSnapchat', headerName: 'Snapchat', src: SnapchatSvg },
  { field: 'isSpotify', headerName: 'Spotify', src: SpotifySvg },

  { field: 'isTikTok', headerName: 'TikTok', src: TikTokSvg },
  { field: 'isYoutube', headerName: 'Youtube', src: YoutubeSvg },
  { field: 'isSeo1', headerName: 'SEO1', src: Seo1Svg },
  { field: 'isSeo2', headerName: 'SEO2', src: Seo2Svg },
  { field: 'isSeo3', headerName: 'SEO3', src: Seo3Svg },
  { field: 'isSeo4', headerName: 'SEO4', src: Seo4Svg },
]

export const renderChannels = (densityStyles: DensityStyleTypes): GridColDef[] => {
  return channelsArray.map(channel => ({
    field: channel.field,
    headerName: channel.headerName,
    renderHeader: () => (
      <Tooltip title={channel.headerName}>
        <img src={channel.src} alt={channel.headerName} style={{ height: 24 }} />
      </Tooltip>
    ),
    width: 30,
    flex: 0.5,
    headerAlign: 'center',
    disableColumnMenu: true,
    valueGetter: (_value: any, row: any) => {
      return row?.[channel.field] ? 'Yes' : 'No'
    },
    renderCell: (params: GridRenderCellParams) => {
      const isTrue = params?.value === 'Yes'
      if ((params?.rowNode as any)?.isAutoGenerated) return null
      return (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            padding: densityStyles.padding,
            gap: densityStyles.gap,
          }}
        >
          {isTrue ? (
            <CheckCircleIcon
              sx={{
                height: '100%',
                color: renderColorByString('Active'),
              }}
            />
          ) : (
            <CheckCircleIcon
              sx={{
                height: '100%',
                color: renderColorByString('Disabled'),
                opacity: '0.2',
              }}
            />
          )}
        </Box>
      )
    },
  }))
}
